/**
 * Strings of the voice extras (2026-11-01): noise suppression, priority
 * speaker, AFK auto-move and voice channel status. English only.
 */
import type { Dict } from './core';

export const voiceExtrasEn: Dict = {
  // noise suppression (Settings › Voice)
  'vx.ns.title': 'Noise suppression',
  'vx.ns.off': 'Off',
  'vx.ns.standard': 'Standard',
  'vx.ns.strong': 'Strong',
  'vx.ns.sub.off': 'Your microphone as it is, with no noise suppression.',
  'vx.ns.sub.standard': "Your browser's own noise suppression.",
  'vx.ns.sub.strong':
    'Removes background noise such as keyboards, fans and traffic, on your device. Uses a little more processing.',
  'vx.ns.strongOff': 'Strong is turned off by the admins right now, so Standard is used.',
  'vx.ns.unsupported': "This browser can't run Strong, so Standard is used.",
  'vx.ns.fellBack': "Strong couldn't start here, so Standard is used.",
  // the browser does echo cancellation and gain control; noise has its own setting now
  'ns.voice.processing':
    "Echo cancellation and gain control use your browser's built-in processing.",

  // priority speaker
  'vx.key.priority': 'Priority speaker',
  'vx.key.prioritySub':
    'Hold to talk as a priority speaker: everyone else in the channel is turned down while you talk. Needs the Priority Speaker permission there. Works while Neosocial is focused.',
  'vx.prio.on': 'Priority speaker',
  'ns.perm.PRIORITY_SPEAKER': 'Priority Speaker',
  'ns.permd.PRIORITY_SPEAKER':
    'Lets members be heard more easily: while they hold their priority speaker key, everyone else in the channel is turned down.',

  // AFK (Server settings › Overview)
  'vx.afk.title': 'Inactivity',
  'vx.afk.channel': 'AFK channel',
  'vx.afk.channelSub':
    'Members idle in voice for the AFK timeout (no talking and no input) are moved here.',
  'vx.afk.none': 'No AFK channel',
  'vx.afk.timeout': 'AFK timeout',
  'vx.afk.min': '{n} min',
  'vx.afk.hour': '1 hour',
  'vx.afk.off': 'AFK auto-move is turned off by the admins right now.',

  // voice channel status
  'vx.st.label': 'Channel status',
  'vx.st.set': 'Set a channel status',
  'vx.st.edit': 'Edit channel status',
  'vx.st.placeholder': "What's happening in here?",
  'vx.st.save': 'Save',
  'vx.st.clear': 'Clear status',
  'vx.st.cancel': 'Cancel',
  'vx.st.count': '{n}/{max}',
  'ns.perm.SET_VOICE_CHANNEL_STATUS': 'Set Voice Channel Status',
  'ns.permd.SET_VOICE_CHANNEL_STATUS':
    'Lets members set the status line of a voice channel they are in.',

  // the console's flags, when the server says one is off
  'cfg.off.noise_suppression': 'Strong noise suppression is turned off by the admins right now.',
  'cfg.off.priority_speaker': 'Priority speaker is turned off by the admins right now.',
  'cfg.off.afk_move': 'AFK auto-move is turned off by the admins right now.',
  'cfg.off.voice_channel_status': 'Voice channel status is turned off by the admins right now.',

  // the audit log
  'vx.audit.afkMove': 'Moved {target} to {channel} for being idle',
  'vx.audit.status': '{actor} set the status of {channel}',
  'vx.audit.statusClear': '{actor} cleared the status of {channel}',
  'vx.audit.f.status': 'Voice channel status',

  // the voice controls as Discord's (2026-11-02): the quick device menus on
  // mute and deafen, the dock's signal and noise toggle, the member menus'
  // Mention and Copy User ID, the stream sounds
  'vx.q.inputDevice': 'Input device',
  'vx.q.outputDevice': 'Output device',
  'vx.q.outputVolume': 'Output volume',
  'vx.q.outputSettings': 'Output settings',
  'vx.q.outputOptions': 'Output options',
  'vx.q.outputMissing': 'Chosen output (not connected)',
  'vx.sig.title': 'Voice connection',
  'vx.sig.good': 'Good connection',
  'vx.sig.ok': 'Fair connection',
  'vx.sig.bad': 'Poor connection',
  'vx.sig.measuring': 'Measuring the ping…',
  'vx.sig.ping': 'Ping',
  'vx.sig.loss': 'Packet loss',
  'vx.sig.pingTip': 'Ping {ms}',
  'vx.nsq.tip': 'Noise suppression: {mode}',
  'vx.m.mention': 'Mention',
  'vx.m.copyId': 'Copy User ID',
  'ns.snd.k.streamStart': 'A stream starts in your channel',
  'ns.snd.k.streamEnd': 'A stream ends in your channel',
  'ns.snd.k.viewerJoin': 'Someone starts watching your stream',
  'ns.snd.k.viewerLeave': 'Someone stops watching your stream',
};
